import { MenuProps } from 'antd';
import _ from 'lodash';
import { proxy } from 'valtio';
import routeList from '@/router/routerMap';
import bus from '@/utils/bus';
import { DetailVO, UserInfo, UserVO } from '../api/auth/types';
import { getUserClickApi } from '../api/home/home';
import { LzMenu } from '../Types/LzMenu';
import { createSubMenu } from '../utils/menuTool';

type MenuItem = Required<MenuProps>['items'][number];

const SHOP_STORAGE_KEY = 'currentShopId';
const SHOP_PLATFORM_STORAGE_KEY = 'currentShopPlatformType';
const SHOP_LIST_STORAGE_KEY = 'availableShopList';
const SHOP_IS_POP_KEY = 'currentShopIsPop';
const SHOP_TYPE_STORAGE_KEY = 'currentShopType';

const normalizeIsPop = (val: number | string | null | undefined) => {
  const num = Number(val);
  return Number.isNaN(num) ? null : num;
};

const normalizeShopType = (val: number | string | null | undefined) => {
  const num = Number(val);
  return Number.isNaN(num) ? null : num;
};

const persistedShopId = (() => {
  if (typeof window === 'undefined') return null;
  try {
    const cache = localStorage.getItem(SHOP_STORAGE_KEY);
    if (!cache) return null;
    const parsed = Number(cache);
    return Number.isNaN(parsed) ? null : parsed;
  } catch (error) {
    return null;
  }
})();

const persistedShopPlatformType = (() => {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(SHOP_PLATFORM_STORAGE_KEY) || null;
  } catch (error) {
    return null;
  }
})();

const persistedShopList = (() => {
  if (typeof window === 'undefined') return [];
  try {
    const cache = localStorage.getItem(SHOP_LIST_STORAGE_KEY);
    if (!cache) return [];
    const parsed = JSON.parse(cache);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
})();

const findPersistedCurrentShop = () => {
  if (!persistedShopId) return null;
  return persistedShopList.find((shop: any) => String(shop?.shopId) === String(persistedShopId)) || null;
};

const persistedShopIsPop = (() => {
  if (typeof window === 'undefined') return null;
  try {
    const cache = localStorage.getItem(SHOP_IS_POP_KEY);
    if (!cache) return normalizeIsPop(findPersistedCurrentShop()?.isPop);
    const parsed = Number(cache);
    return Number.isNaN(parsed) ? null : parsed;
  } catch (error) {
    return null;
  }
})();

const persistedShopType = (() => {
  if (typeof window === 'undefined') return null;
  try {
    const cache = localStorage.getItem(SHOP_TYPE_STORAGE_KEY);
    if (!cache) return normalizeShopType(findPersistedCurrentShop()?.shopType);
    const parsed = Number(cache);
    return Number.isNaN(parsed) ? null : parsed;
  } catch (error) {
    return null;
  }
})();

const initalState = {
  menu: [] as LzMenu[],
  currentMenuIndex: 0,
  subMenu: [] as MenuItem[],
  selectedKeys: [] as string[],
  defaultOpenKeys: [] as string[],
  currentPath: '',
  isArrow: true,
  labelId: 0,
  checkLabelType: '1', //1全部标签 2我创建的
  token: '',
  client_id: '',

  permissions: [] as string[],
  roles: [] as string[],
  user: {} as UserVO,
  detail: {} as DetailVO,
  groupDetail: {} as any,
  systemHide: '' as string,

  NOT_NEED_LOAD_URL: [
    '/system/user/list',
    '/auth/codeByUserName',
    '/label/label/getLabelUserStat',
    '/label/label/labelStatusManage',
    '/label/label/queryLabelInfoDetail',
    '/label/label/getLabelUserStat',
    '/system/home/click',
    '/chat/chat/conversation',
    '/chat/chat/interpretation',
  ],
  parentMenuId: 0 as any,
  childMenuId: 0 as any,
  styleStoreData: {} as any,
  dataPermission: '',
  dataPermissionInfo: null as any,
  detalFieldHide: {} as any,
  listFieldHide: [] as any,
  rmfKey: '',
  jumpLink: '' as any, //帮助中心跳转链接
  rfmName: '',
  operatorEnums: null as any,
  shopList: persistedShopList,
  currentShopId: persistedShopId,
  currentShopPlatformType: persistedShopPlatformType,
  currentShopIsPop: persistedShopIsPop as number | null,
  /**
   * 店铺类型 1处方粮,2日粮
   */
  currentShopType: persistedShopType as number | null,
  // tableScrollY: '' as any
};
let allMenu: any = [];
const extractKeys = (data: any) => {
  data.forEach((item: any) => {
    allMenu.push({
      key: item.key,
      menuId: item.menuId,
    });
    if (item.children) {
      extractKeys(item.children);
    }
  });
};

export const changeCurrentMenuIndex = (index: number, key?: string) => {
  state.currentMenuIndex = index;
  bus.emit('menuSwitch', Boolean(state.menu[state.currentMenuIndex] && state.menu[state.currentMenuIndex].children));

  if (state.menu.length > 0) {
    state.subMenu = createSubMenu(state.menu[state.currentMenuIndex].children || []);
    state.defaultOpenKeys = state.subMenu.map(obj => (obj ? obj.key?.toString() : [])) as string[];
    allMenu = [];
    extractKeys(state.menu);
    // 埋点参数 ———— menuId: number, level: number, crowdId: number, labelId: number, parentId: number, router: any
    getUserClickApi(state.menu[index].menuId, 1, undefined, undefined, state.menu[index].menuId, undefined);

    const currentIndex = allMenu.findIndex((it: any) => it.key === key);

    if (key) {
      if (currentIndex >= 0) {
        state.parentMenuId = state.menu[index].menuId;
        if (state.menu[index].menuId !== 1688) {
          // 1688--首页没有子级菜单，只用调一次埋点接口
          // const menuIndex = allMenu.findIndex((it: any) => it.key === key)
          getUserClickApi(allMenu[currentIndex].menuId, 3, undefined, undefined, state.menu[index].menuId, undefined);
          state.childMenuId = allMenu[currentIndex].menuId;
        }
      }

      // 解决同一个菜单下使用路由跳转到该菜单下的另一页面，左侧菜单不高亮问题
      // const levelIndex = allMenu.findIndex((it: any) => key.indexOf(it.key) > -1)
      const t: any[] = _.filter(routeList, function (o: any) {
        return o.path === key;
      });
      let a = key;
      if (t[0].parentKey) {
        a = t[0].parentKey;
      }
      state.selectedKeys = [a, `${a.split('/')[2]}`];
    }
  }
};

export const setMenu = (menu: LzMenu[]) => {
  state.menu = menu;
  state.subMenu = menu.length < 1 ? [] : createSubMenu(menu[state.currentMenuIndex].children || []);
};

export const setSelectkeys = (arr: string[]) => {
  state.selectedKeys = arr;
};

export const setOpenKeys = (arr: string[]) => {
  state.defaultOpenKeys = arr;
  console.log(state.defaultOpenKeys);
};

export const setCurrentPath = (s: string) => {
  state.currentPath = s;
};

export const setArrow = (arrow: boolean) => {
  state.isArrow = arrow;
};

export const setUserToken = (token: string, client_Id: string) => {
  state.token = token;
  state.client_id = client_Id;
  localStorage.setItem('userToken', token);
};

export const setUserInfo = (userInfo: UserInfo) => {
  state.permissions = userInfo.permissions;
  state.roles = userInfo.roles;
  state.user = userInfo.user;
  state.detalFieldHide = userInfo.detalFieldHide;
  state.listFieldHide = userInfo.listFieldHide;
  state.rmfKey = userInfo.rmfKey;
  state.systemHide = userInfo.systemHide;
};

export const setJumpLink = (link: any) => {
  state.jumpLink = link;
};

export const setUserDetail = (userDetail: any) => {
  state.detail = userDetail;
};

export const setStateLabelId = (labelId: any) => {
  state.labelId = labelId;
};

export const setStyleStoreData = (data: any) => {
  state.styleStoreData = data;
  // 给浏览器左上角改为动态取图标
  const createLink = (rel: string, href: string) => {
    const link: any = document.querySelector(`link[rel*='${rel}']`) || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = rel;
    link.href = href;
    document.getElementsByTagName('head')[0].appendChild(link);
  };
  const iconUrl = state.styleStoreData.iconUrl;
  createLink('icon', iconUrl);
  createLink('apple-touch-icon', iconUrl);
};

export const setDataPermission = (dataPermission: string) => {
  state.dataPermission = dataPermission;
};

export const setDataPermissionInfo = (dataPermissionInfo: any) => {
  state.dataPermissionInfo = dataPermissionInfo ?? null;
  if (dataPermissionInfo !== undefined && dataPermissionInfo !== null) {
    localStorage.setItem('dataPermissionInfo', JSON.stringify(dataPermissionInfo));
  } else {
    localStorage.removeItem('dataPermissionInfo');
  }
};

export const getCachedShopIds = () => {
  if (state.dataPermissionInfo?.shopIds) {
    return state.dataPermissionInfo.shopIds;
  }
  try {
    const cache = localStorage.getItem('dataPermissionInfo');
    if (cache) {
      const parsed = JSON.parse(cache);
      return parsed?.shopIds || [];
    }
  } catch (error) {
    console.warn('Failed to parse dataPermissionInfo from cache', error);
  }
  return [];
};
export const setCheckLabelType = (type: any) => {
  state.checkLabelType = type;
};

export const setRfmName = (str: string) => {
  state.rfmName = str;
};

export const setOperatorEnums = (data: any) => {
  state.operatorEnums = data;
};

export const setShopList = (list: any[]) => {
  const safeList = Array.isArray(list) ? list : [];
  state.shopList = safeList;
  if (typeof window === 'undefined') return;
  localStorage.setItem(SHOP_LIST_STORAGE_KEY, JSON.stringify(safeList));
};

export const setCurrentShopPlatformType = (platformType: string | null) => {
  state.currentShopPlatformType = platformType ?? null;
  if (typeof window === 'undefined') return;
  if (platformType !== null && platformType !== undefined) {
    localStorage.setItem(SHOP_PLATFORM_STORAGE_KEY, String(platformType));
  } else {
    localStorage.removeItem(SHOP_PLATFORM_STORAGE_KEY);
  }
};

export const setCurrentShopIsPop = (isPop: number | string | null) => {
  const normalized = normalizeIsPop(isPop);
  state.currentShopIsPop = normalized;
  if (typeof window === 'undefined') return;
  if (normalized !== null && normalized !== undefined) {
    localStorage.setItem(SHOP_IS_POP_KEY, String(normalized));
  } else {
    localStorage.removeItem(SHOP_IS_POP_KEY);
  }
};

export const setCurrentShopType = (shopType: number | string | null) => {
  const normalized = normalizeShopType(shopType);
  state.currentShopType = normalized;
  if (typeof window === 'undefined') return;
  if (normalized !== null && normalized !== undefined) {
    localStorage.setItem(SHOP_TYPE_STORAGE_KEY, String(normalized));
  } else {
    localStorage.removeItem(SHOP_TYPE_STORAGE_KEY);
  }
};

export const setCurrentShopId = (
  shopId: number | null,
  platformType?: string | null,
  shopType?: number | string | null,
) => {
  state.currentShopId = shopId ?? null;
  if (typeof window === 'undefined') return;
  if (shopId !== null && shopId !== undefined) {
    localStorage.setItem(SHOP_STORAGE_KEY, String(shopId));
    const currentShop = state.shopList.find((shop: any) => String(shop?.shopId) === String(shopId));
    if (platformType !== undefined) {
      setCurrentShopPlatformType(platformType ?? null);
    }
    if (currentShop && currentShop.isPop !== undefined) {
      setCurrentShopIsPop(currentShop.isPop ?? null);
    }
    if (shopType !== undefined) {
      setCurrentShopType(shopType ?? null);
    } else if (currentShop && currentShop.shopType !== undefined) {
      setCurrentShopType(currentShop.shopType ?? null);
    }
  } else {
    localStorage.removeItem(SHOP_STORAGE_KEY);
    if (platformType !== undefined) {
      setCurrentShopPlatformType(null);
    }
    setCurrentShopIsPop(null);
    setCurrentShopType(null);
  }
};

export const state = proxy({ ...initalState });

// 计算当前列表高度

/**
 * 获取第一个表格的可视化高度
 * @param {*} extraHeight 额外的高度(表格底部的内容高度 Number类型,默认为74)
 * @param {*} id 当前页面中有多个table时需要制定table的id
 */
export const getTableScroll = (extraHeight?: number, id?: any) => {
  if (typeof extraHeight == 'undefined') {
    //  默认底部分页64 + 边距10
    // 64+24=88
    // 118-24-24 == 70
    //   extraHeight = 94
    extraHeight = 70;
  }
  let tHeader = null;
  if (id) {
    tHeader = document.getElementById(id)
      ? document.getElementById(id)?.getElementsByClassName('ant-table-thead')[0]
      : null;
  } else {
    tHeader = document.getElementsByClassName('ant-table-thead')[0];
  }
  //表格内容距离顶部的距离
  let tHeaderBottom = 0;
  if (tHeader) {
    tHeaderBottom = tHeader.getBoundingClientRect().bottom;
  }
  //窗体高度-表格内容顶部的高度-表格内容底部的高度
  // let height = document.body.clientHeight - tHeaderBottom - extraHeight
  // console.log(tHeaderBottom, extraHeight, 'tHeaderBottom + extraHeight');

  let height = `calc(100vh - ${tHeaderBottom + extraHeight}px)`;
  // localStorage.setItem('tableScrollY', height)
  // set TableScrollY(height)
  // console.log(height, 'height3333333333333333333333333333');
  // state.tableScrollY = height

  return height;
};
